import { useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { SETTINGS_TYPES } from '@/constant'
import { SettingsService } from '@/services/SettingsService'
import {
  applyPlatformThemeColors,
  getPlatformThemeColors,
  PLATFORM_THEME_COLORS_CHANGE_EVENT,
  PLATFORM_THEME_COLORS_SETTING_KEY,
} from '@/helpers/themeCustomization'

const getCachedSetting = () => {
  if (typeof window === 'undefined') return undefined

  try {
    return JSON.parse(localStorage.getItem(SETTINGS_TYPES.CUSTOM))?.[
      PLATFORM_THEME_COLORS_SETTING_KEY
    ]
  } catch {
    return undefined
  }
}

export const usePlatformThemeColors = (theme) => {
  const [setting, setSetting] = useState(getCachedSetting)

  useLayoutEffect(() => {
    applyPlatformThemeColors(setting, theme)
  }, [setting, theme])

  useEffect(() => {
    const handleColorsChange = (event) => setSetting(event.detail?.value)

    window.addEventListener(
      PLATFORM_THEME_COLORS_CHANGE_EVENT,
      handleColorsChange,
    )

    SettingsService.getCorrected(SETTINGS_TYPES.CUSTOM).then((settings) => {
      if (settings) {
        setSetting(settings[PLATFORM_THEME_COLORS_SETTING_KEY])
      }
    })

    return () => {
      window.removeEventListener(
        PLATFORM_THEME_COLORS_CHANGE_EVENT,
        handleColorsChange,
      )
    }
  }, [])

  return useMemo(() => getPlatformThemeColors(setting, theme), [setting, theme])
}
